import { createFileRoute, redirect } from '@tanstack/react-router'

import keycloak from '@/core/keycloak'
import Profile from '@/signup/components/Profile'

export const Route = createFileRoute('/signup/profile')({
  beforeLoad: async () => {
    if (!keycloak.authenticated) {
      throw redirect({ href: keycloak.createLoginUrl() })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Profile />
}
